import React from 'react';
import FormSelectField from '../../../../components/form/select-field';
import ContactDetails from '../contact-details/contact-details';
import FormError from '../../../../components/form/error/error';
import {
  SITE_CONTACT_FIRST_NAME,
  SITE_CONTACT_LAST_NAME,
  SITE_CONTACT_PHONE,
  SITE_CONTACT_EMAIL,
  SITE_STATUS_PARTIALLY_SAVED,
  SITE_STATUS_SUBMITTED,
} from '../../../../app-constants';
import './site-details.css';

const SiteDetails = (props) => {
  const { siteDetailHeading, siteAddressList, siteListSelectedValue, handleSiteAddressListOnBlur,
    authorableSitesData, siteContactFormFieldsState, handleOnBlur, handleOnChange,
    selectedSiteContactFormErrors, showSiteContactErrorMessage, siteStatusAuthorableContent,
    siteStatusData, siteId } = props;

  const siteContactFormFieldsIds = {
    firstName: SITE_CONTACT_FIRST_NAME,
    lastName: SITE_CONTACT_LAST_NAME,
    email: SITE_CONTACT_EMAIL,
    phone: SITE_CONTACT_PHONE,
  };

  const getSiteStatus = (addressSiteId) => {
    const siteStatusValue = siteStatusData && siteStatusData[addressSiteId] !== undefined ? siteStatusData[addressSiteId] : 'NOT_STARTED';

    if (siteStatusValue === SITE_STATUS_PARTIALLY_SAVED) {
      return siteStatusAuthorableContent.partiallySavedText;
    } else if (siteStatusValue === SITE_STATUS_SUBMITTED) {
      return siteStatusAuthorableContent.submittedText;
    }
    return siteStatusAuthorableContent.notStartedText;
  };

  const siteAddressListWithStatus = siteAddressList.map((address) => {
    const newValue = `<span class='dropdown-text-left'>${address.value}</span><span class='dropdown-text-right'>${getSiteStatus(address.id)}</span>`;
    return { ...address, htmlText: newValue };
  });

  const siteAddressHtmlValue = `<span class='dropdown-text-left'>${siteListSelectedValue}</span>
    <span class='dropdown-text-right'>${getSiteStatus(siteId)}</span>`;

  return (
    <div className="site-details">
      <div className="row">
        <div className="col-12 pl-sm-0">
          <h2 id="site-details-heading" className="site-detail-heading">{siteDetailHeading}</h2>
        </div>
        <div className="site-list-details col-12 pl-sm-0">
          <FormSelectField
            id="sites-list"
            label=""
            disabled={false}
            options={siteAddressListWithStatus}
            value={siteListSelectedValue}
            htmlValue={siteAddressHtmlValue}
            onBlur={handleSiteAddressListOnBlur}
            placeholder=""
            initialValuePresent
            htmlTextPresent
          />
        </div>
      </div>
      <ContactDetails
        sectionHeadingText={authorableSitesData.siteContactHeadingText}
        formFields={authorableSitesData.siteContactFormFields}
        selectedSiteContactFormErrors={selectedSiteContactFormErrors}
        formFieldsIds={siteContactFormFieldsIds}
        formFieldsState={siteContactFormFieldsState}
        handleOnBlur={handleOnBlur}
        handleOnChange={handleOnChange}
      />
      {(showSiteContactErrorMessage && authorableSitesData.siteContactErrorMessageText)
        && (
          <div className="row">
            <div className="col-12 pl-sm-0">
              <FormError errorText={authorableSitesData.siteContactErrorMessageText} />
            </div>
          </div>
        )}

    </div>
  );
};

export default SiteDetails;
